import axios from "./axios_interceptor";
import file_manager_config from "./file_manager_config";
import { get_jwt_token, loginRedirect } from "./helper_funtions";
import { setFileTranferUploadList, setFileDownloadList, setShowProgressContainer, registerActiveUpload, removeActiveUpload, } from "../state/slices/file_manager";
import { decodeResourceParams } from '../utils/urlEncoder';
import { CHUNK_SIZE } from "../components/dashboard/FileManager/constants";

const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const data = urlParams.get('data');
  if (data) {
    const decoded = decodeResourceParams(data);
    return {
      resource_id: decoded.resource_id,
      systemuser_id: decoded.systemuser_id,
      resource_type: decoded.resource_type,
      token_key: decoded.token_key,
      token_value: decoded.token_value,
      prompt_key_credentials: urlParams.get("prompt_key_credentials"),
    };
  }
  else
    return null
};

export const list = async (path) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);

    let url =
      file_manager_config.url_list +
      `&path=${encodeURIComponent(path || "/")}` +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    if (params.prompt_key_credentials) {
      url += `&prompt_key_credentials=${params.prompt_key_credentials}`;
    }

    const response = await axios.get(url, config);

    if (response.data.resource_access_report_id) {
      sessionStorage.setItem(
        `${params.token_key}`,
        response.data.resource_access_report_id,
      );
    }
    return { data: response.data.file_list, error: null, statusCode: response.data?.statusCode || response.status }
  } catch (e) {
    return {
      data: null,
      error: e.response?.data?.errors || e.response?.data,
      statusCode:
        e.response?.data?.statusCode || e.response?.status
    };
  }
};

export const createDirectory = async (path, directory) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      directory,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_create_folder +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`
    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const getFileContent = async (path) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_get_content +
      "&path=" +
      (encodeURIComponent(path) || "/") +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const getFileContentDownload = async (dispatch, path, fileNameHint = "downloaded_file.bin") => {
  const token = get_jwt_token();
  const params = getUrlParams();
  const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
  let unique_id = `${window.name}_${path || "/"}`;
  let url =
    file_manager_config.url_get_content +
    `&path=${encodeURIComponent(path || "/")}` +
    `&resource_id=${params.resource_id}` +
    `&systemuser_id=${params.systemuser_id}` +
    `&resource_type=${params.resource_type}` +
    `&token_key=${params.token_key}` +
    `&token_value=${params.token_value}` +
    `&session_key=${params.session_key}`;

  if (resource_access_report_id) {
    url += `&resource_access_report_id=${resource_access_report_id}`;
  }

  const store = require("../state/store").store;
  const state = store.getState();
  const baseURL = state?.customer?.serverUrl;
  const fullUrl = `${baseURL}${url}`;

  dispatch(setShowProgressContainer(true));

  const controller = new AbortController();
  const signal = controller.signal;

  const isCancelled = () => signal.aborted;
  const isAbortError = (error) => {
    return error?.name === 'AbortError' ||
      error?.name === 'CanceledError' ||
      error?.code === 'ERR_CANCELED' ||
      isCancelled();
  };

  dispatch(registerActiveUpload({
    unique_id: unique_id,
    controller: controller,
    filename: fileNameHint,
    path: path
  }));

  try {
    const response = await fetch(fullUrl, {
      headers: { Authorization: `Bearer ${token}` },
      signal: signal,
    });

    if (!response.ok) {
      throw new Error(`Download failed: ${response.statusText}`);
    }

    const contentDisposition = response.headers.get("Content-Type");
    const contentLength = response.headers.get("Content-Length");
    const totalBytes = contentLength ? parseInt(contentLength, 10) : 0;

    let fileName = fileNameHint;
    if (contentDisposition && contentDisposition.includes("filename=")) {
      fileName = contentDisposition.split("filename=")[1].replace(/["']/g, "");
    }

    const canUseSaveFilePicker = "showSaveFilePicker" in window;
    if (canUseSaveFilePicker) {
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: fileName,
        types: [
          {
            description: "All Files",
            accept: { "application/octet-stream": [".bin"] },
          },
        ],
      });

      const writableStream = await fileHandle.createWritable();
      const reader = response.body.getReader();

      let receivedBytes = 0;
      const startTime = performance.now();

      try {
        while (true) {
          if (signal.aborted) {
            await reader.cancel();
            break;
          }

          const { done, value } = await reader.read();
          if (done) break;

          await writableStream.write(value);
          receivedBytes += value.length;

          const progress = totalBytes
            ? ((receivedBytes / totalBytes) * 100).toFixed(2)
            : "0";

          dispatch(
            setFileDownloadList({
              type: "progress",
              file_name: fileName,
              received: receivedBytes.toString(),
              total: totalBytes.toString(),
              progress,
              unique_id: unique_id,
              path: path
            })
          );
        }

      } finally {
        await writableStream.close();
        dispatch(removeActiveUpload({ unique_id: unique_id }));
      }
    } else {
      const dbName = "FileDownloadDB";
      const storeName = "chunks";
      const dbRequest = indexedDB.open(dbName, 1);

      dbRequest.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { autoIncrement: true });
        }
      };

      const db = await new Promise((resolve, reject) => {
        dbRequest.onsuccess = () => resolve(dbRequest.result);
        dbRequest.onerror = () => reject(dbRequest.error);
      });

      const clearTx = db.transaction(storeName, "readwrite");
      clearTx.objectStore(storeName).clear();
      await new Promise((resolve) => (clearTx.oncomplete = resolve));

      const reader = response.body.getReader();
      let receivedBytes = 0;

      try {
        while (true) {
          if (signal.aborted) {
            await reader.cancel();
            break;
          }

          const { done, value } = await reader.read();
          if (done) break;

          const tx = db.transaction(storeName, "readwrite");
          tx.objectStore(storeName).add(value);
          await new Promise((resolve) => (tx.oncomplete = resolve));

          receivedBytes += value.length;
          const progress = totalBytes
            ? ((receivedBytes / totalBytes) * 100).toFixed(2)
            : "0";

          dispatch(
            setFileDownloadList({
              type: "progress",
              file_name: fileName,
              received: receivedBytes.toString(),
              total: totalBytes.toString(),
              progress,
              unique_id: unique_id,
              path: path
            })
          );
        }

        if (!signal.aborted) {
          const allChunks = [];
          const readTx = db.transaction(storeName, "readonly");
          const cursorRequest = readTx.objectStore(storeName).openCursor();

          await new Promise((resolve, reject) => {
            cursorRequest.onsuccess = (event) => {
              const cursor = event.target.result;
              if (cursor) {
                allChunks.push(cursor.value);
                cursor.continue();
              } else {
                resolve();
              }
            };
            cursorRequest.onerror = () => reject(cursorRequest.error);
          });

          const blob = new Blob(allChunks, { type: "application/octet-stream" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } finally {
        dispatch(removeActiveUpload({ unique_id: unique_id }));
        const deleteTx = db.transaction(storeName, "readwrite");
        deleteTx.objectStore(storeName).clear();
      }
    }

    if (!isCancelled()) {
      dispatch(
        setFileDownloadList({
          file_name: fileName,
          action: "completed",
          progress: 100,
          transferred: "Complete",
          total: "Complete",
        })
      );
    }

    // For metrics/logging, though startTime might not be defined in fallback path
    // const elapsed = ((performance.now() - (startTime || 0)) / 1000).toFixed(2);
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }
    dispatch(
      setFileDownloadList({
        file_name: fileNameHint,
        action: "failed",
      })
    );
  }
};

export const remove = async (path, filenames, recursive = true) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      filenames,
      recursive,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_remove +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const zip = async (path, filenames, recursive = true) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      filenames,
      recursive,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_zip +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const unzip = async (path, filenames, recursive = true) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      filenames,
      recursive,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_unzip +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const move = async (path, destination, filenames, saveAsMap = {}) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      destination,
      filenames,
      save_as_map: saveAsMap,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_move + `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const rename = async (path, destination, overwrite = false) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      destination,
      overwrite,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_rename +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};

export const copy = async (path, destination, filenames, saveAsMap = {}) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let data = {
      path,
      destination,
      filenames,
      save_as_map: saveAsMap,
    };
    const params = getUrlParams();
    const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
    let url =
      file_manager_config.url_copy +
      `&resource_id=${params.resource_id}` +
      `&systemuser_id=${params.systemuser_id}` +
      `&resource_type=${params.resource_type}` +
      `&token_key=${params.token_key}` +
      `&token_value=${params.token_value}`

    if (resource_access_report_id) {
      url += `&resource_access_report_id=${resource_access_report_id}`;
    }
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.response?.data, statusCode: e.response?.status };
  }
};


export const uploadFiles = async (dispatch, file, path, finalName, abortSignal = null) => {
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const responses = [];
  const token = get_jwt_token();
  loginRedirect(token);

  const params = getUrlParams();
  const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
  const pathPart = path && path !== "/" ? `${path}/` : "";
  let unique_id = `${window.name}_${pathPart}${finalName}`;
  let url =
    file_manager_config.url_upload +
    `&resource_id=${params.resource_id}` +
    `&systemuser_id=${params.systemuser_id}` +
    `&resource_type=${params.resource_type}` +
    `&token_key=${params.token_key}` +
    `&token_value=${params.token_value}` +
    `&session_key=${params.session_key}`;
  if (resource_access_report_id) {
    url += `&resource_access_report_id=${resource_access_report_id}`;
  }

  const isCancelled = () => {
    return abortSignal && abortSignal.aborted;
  };
  const isAbortError = (error) => {
    return error?.name === 'AbortError' ||
      error?.name === 'CanceledError' ||
      error?.code === 'ERR_CANCELED' ||
      error?.message === 'Upload aborted' ||
      isCancelled();
  };

  try {
    for (let i = 0; i < totalChunks; i++) {
      if (isCancelled()) {
        break;
      }

      const start = i * CHUNK_SIZE;
      const end = Math.min(file.size, start + CHUNK_SIZE);
      const chunk = file.slice(start, end);
      if (isCancelled()) {
        break;
      }

      const formData = new FormData();
      formData.append("chunk", chunk);
      formData.append("path", `${path}/${finalName}`);
      formData.append("chunk_index", i);
      formData.append("total_chunks", totalChunks);
      formData.append("chunk_size", CHUNK_SIZE);
      try {

        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: abortSignal,
        });

        if (isCancelled()) {
          break;
        }

        responses.push(response.data);

        const percent = Math.round(((i + 1) / totalChunks) * 100);

        if (!isCancelled()) {
          dispatch(
            setFileTranferUploadList({
              type: "progress",
              file_name: finalName,
              progress: percent,
              received: end.toString(),
              total: file.size.toString(),
              unique_id: unique_id,
            })
          );
        }
      } catch (axiosError) {
        if (isAbortError(axiosError)) {
          break;
        }
        throw axiosError;
      }
    }
    const finalCancelledState = isCancelled();
    if (!finalCancelledState) {
      dispatch(
        setFileTranferUploadList({
          type: "progress",
          file_name: finalName,
          progress: 100,
          received: file.size.toString(),
          total: file.size.toString(),
          unique_id: unique_id,
        })
      );

      return { data: responses, error: null };
    } else {
      return { data: responses, error: 'Cancelled' };
    }
  } catch (e) {
    if (isAbortError(e)) {
      return { data: responses, error: 'Cancelled' };
    }
    const errorCancelledState = isCancelled();
    if (!errorCancelledState) {
      dispatch(
        setFileTranferUploadList({
          type: "progress",
          file_name: finalName,
          progress: 0,
          received: "0",
          total: file.size.toString(),
          error: "Upload failed",
          unique_id: unique_id,
        })
      );

    }

    return { data: responses, error: e.message };
  }
};


export const closeFileTransferConnection = async (useBeacon = true) => {
  const token = get_jwt_token();

  if (!useBeacon) {
    loginRedirect(token);
  }

  const params = getUrlParams();
  const resource_access_report_id = sessionStorage.getItem(`${params.token_key}`);
  const requestBody = {
    resource_id: params.resource_id,
    resource_type: params.resource_type,
    systemuser_id: params.systemuser_id,
    session_key: params.session_key,
    token_key: params.token_key,
    resource_access_id: resource_access_report_id,
  };

  const closeEndpoint = `/file_manager/close_file_transfer_connection/`;

  if (useBeacon && navigator.sendBeacon) {
    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(requestBody));
      formData.append("token", token);

      let state = null;
      const store = require("../state/store").store;
      state = store.getState();

      const baseURL = state?.customer?.serverUrl || window.location.origin;
      const beaconUrl = `${baseURL}${closeEndpoint}?beacon=true`;
      const sent = navigator.sendBeacon(beaconUrl, formData);

      return { success: sent, method: "beacon" };
    } catch (error) {
      return { success: false, error };
    }
  }
};
